module.exports = __webpack_public_path__ + "static/media/square.cee5bade.svg";